import React from 'react';
import { ReactSVG } from 'react-svg';
import {
    SideWaveIndicator,
    SideWaveOption,
    SideWavePill,
    SideWaveVisual,
} from './styles';

type Directions = 'Right' | 'Left';

type SideWaveProps = {
    direction: Directions;
    onSelect: (select: Directions) => void;
};

const objFilter: Record<Directions, string> = {
    Left: 'Esquerda',
    Right: 'Direita',
};

const directionOrder: Directions[] = ['Left', 'Right'];

export const SideWave: React.FC<SideWaveProps> = ({ direction, onSelect }) => {
    const activeIndex = directionOrder.indexOf(direction);

    return (
        <SideWavePill role="radiogroup" aria-label="Direção da onda">
            <SideWaveIndicator
                aria-hidden="true"
                $activeIndex={activeIndex}
            />
            {directionOrder.map(option => (
                <SideWaveOption
                    key={option}
                    type="button"
                    role="radio"
                    aria-label={`Selecionar direção ${objFilter[option]}`}
                    aria-checked={direction === option}
                    aria-pressed={direction === option}
                    $isActive={direction === option}
                    onClick={() => onSelect(option)}
                >
                    <SideWaveVisual $isLeft={option === 'Left'}>
                        <ReactSVG src="/images/splitScreen.svg" />
                    </SideWaveVisual>
                    <span>{objFilter[option]}</span>
                </SideWaveOption>
            ))}
        </SideWavePill>
    );
};
